<template>
    <div class="form-element checkbox-options-input-element"
         v-bind:class="{'border-alert': errorMessages.currentMessage}">
        <div class="question" v-html="label"></div>
        <div class="checkbox-input-group">
            <div v-for="(checkboxItem, index) in items" :key="index" class="checkbox-input-item">
                <input type="checkbox" :id="id + index" v-model="localModel" :value="checkboxItem">
                <label :for="id + index">
                    {{ checkboxItem }}
                </label>
            </div>
        </div>
        <p v-if="errorMessages.currentMessage" class="error-message">{{ errorMessages.currentMessage }}</p>
    </div>
</template>

<script>
import {validationMixin} from '../mixins/ValidationMixin';

export default {
    props: {
        'label': String,
        'value': Array,
        'id': String,
        'items': Array,
        'step': Number
    },
    data() {
        return {
            internalValue: [],
            errorMessages: {
                currentMessage: '',
                messages: [
                    'Je moet hier nog een keuze opgeven.'
                ]
            }
        }
    },
    created() {
        this.internalValue = (this.value) ? this.value : [];
        this.validateComponent();
    },
    computed: {
        localModel: {
            get: function () {
                return this.internalValue;
            },
            set: function (value) {
                this.internalValue = value;
                this.validationComponent.isDirty = true;
                this.$emit('update:value', this.internalValue);
                this.validateComponent();
            }
        }
    },
    mixins: [validationMixin]
}
</script>

<style>
.checkbox-input-group {
    @apply border-2;
    @apply border-solid;
    @apply rounded;
    @apply flex;
    @apply flex-col;
    @apply items-start;
    @apply mt-2;
    @apply pt-3;
    @apply pb-3;
    @apply px-3;
}

.checkbox-options-input-element input[type="checkbox"] {
    @apply hidden;
}

.checkbox-input-item {
    @apply relative;
    @apply mb-4;
    @apply pl-8;
}

.checkbox-input-item:last-of-type {
    margin: 0;
}

.checkbox-input-item label {
    line-height: 1.75rem;
}

.checkbox-options-input-element input[type="checkbox"]:checked + label {
    @apply font-bold;
}

.checkbox-options-input-element .checkbox-input-item label:before {
    @apply bg-white;
    @apply border-2;
    @apply border-gray-300;
    @apply border-solid;
    @apply rounded-full;
    @apply w-6;
    @apply h-6;
    @apply absolute;

    content: "";
    font-size: 0;
    left: 0;
    top: 0;
    transition: all 125ms cubic-bezier(.96, .11, .71, 1);
}

.checkbox-options-input-element input[type="checkbox"]:checked + label:before {
    @apply border-2;
    @apply border-primary-500;
    @apply bg-primary-500;
    @apply w-6;
    @apply h-6;
}

.checkbox-options-input-element .checkbox-input-item label:after {
    @apply absolute;

    transition: all 125ms cubic-bezier(1, .71, .11, .96);
    content: '';
    width: 0;
    height: 0;
    left: 0;
    top: 0;
}

.checkbox-options-input-element input[type="checkbox"]:checked + label:after {
    @apply w-6;
    @apply h-6;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg fill='%23FFFFFF' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'/%3E%3C/svg%3E");
    content: '';
    left: 0;
    top: 0;
}
</style>
